export const POWERSCHOOL_INTEGRATION_SAVE_CONFIGURATION =
  'POWERSCHOOL_INTEGRATION_SAVE_CONFIGURATION';
export const POWERSCHOOL_INTEGRATION_FETCHING =
  'POWERSCHOOL_INTEGRATION_FETCHING';
export const POWERSCHOOL_INTEGRATION_LOADING =
  'POWERSCHOOL_INTEGRATION_LOADING';
export const POWERSCHOOL_INTEGRATION_ERROR = 'POWERSCHOOL_INTEGRATION_ERROR';
export const POWERSCHOOL_INTEGRATION_CLEAR_ERROR =
  'POWERSCHOOL_INTEGRATION_CLEAR_ERROR';
export const POWERSCHOOL_ADD_LANGUAGE_MAPPING_DATA =
  'POWERSCHOOL_ADD_LANGUAGE_MAPPING_DATA';
export const POWERSCHOOL_INTEGRATION_SET_CONFIGURATION =
  'POWERSCHOOL_INTEGRATION_SET_CONFIGURATION';



// WEBPACK FOOTER //
// ./src/pages/powerschoolintegration/state/powerschool/types.js